import React, { useState, useEffect } from 'react';
import { FiCommand } from "react-icons/fi";

export const DocumentIcon = () => (
  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const departmentStyles = {
  default: {
    iconBg: 'bg-[#2979ff]',
    cardBorder: 'border-[#2979ff]/30',
    tagBg: 'bg-[#2979ff]/10',
    tagText: 'text-[#2979ff]',
    iconColor: 'text-[#2979ff]',
    buttonBg: 'bg-[#2979ff]/10',
    buttonText: 'text-[#2979ff]',
    buttonBorder: 'border-[#2979ff]/30',
    buttonHover: 'hover:bg-[#2979ff] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#2979ff]/10',
  },
  Comercial: {
    iconBg: 'bg-[#e11970]',
    cardBorder: 'border-[#e11970]/30',
    tagBg: 'bg-[#e11970]/10',
    tagText: 'text-[#e11970]',
    iconColor: 'text-[#e11970]',
    buttonBg: 'bg-[#e11970]/10',
    buttonText: 'text-[#e11970]',
    buttonBorder: 'border-[#e11970]/30',
    buttonHover: 'hover:bg-[#e11970] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#e11970]/10',
  },
  BPO: {
    iconBg: 'bg-[#ff6f00]',
    cardBorder: 'border-[#ff6f00]/30',
    tagBg: 'bg-[#ff6f00]/10',
    tagText: 'text-[#ff6f00]',
    iconColor: 'text-[#ff6f00]',
    buttonBg: 'bg-[#ff6f00]/10',
    buttonText: 'text-[#ff6f00]',
    buttonBorder: 'border-[#ff6f00]/30',
    buttonHover: 'hover:bg-[#ff6f00] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#ff6f00]/10',
  },
  Contabil: {
    iconBg: 'bg-[#2837de]',
    cardBorder: 'border-[#2837de]/30',
    tagBg: 'bg-[#2837de]/10',
    tagText: 'text-[#2837de]',
    iconColor: 'text-[#2837de]',
    buttonBg: 'bg-[#2837de]/10',
    buttonText: 'text-[#2837de]',
    buttonBorder: 'border-[#2837de]/30',
    buttonHover: 'hover:bg-[#2837de] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#2837de]/10',
  },
   Financeiro: {
    iconBg: 'bg-[#008a0b]',
    cardBorder: 'border-[#008a0b]/30',
    tagBg: 'bg-[#008a0b]/10',
    tagText: 'text-[#008a0b]',
    iconColor: 'text-[#008a0b]',
    buttonBg: 'bg-[#008a0b]/10',
    buttonText: 'text-[#008a0b]',
    buttonBorder: 'border-[#008a0b]/30',
    buttonHover: 'hover:bg-[#008a0b] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#008a0b]/10',
  },
  Fiscal: {
    iconBg: 'bg-[#2979ff]',
    cardBorder: 'border-[#2979ff]/30',
    tagBg: 'bg-[#2979ff]/10',
    tagText: 'text-[#2979ff]',
    iconColor: 'text-[#2979ff]',
    buttonBg: 'bg-[#2979ff]/10',
    buttonText: 'text-[#2979ff]',
    buttonBorder: 'border-[#2979ff]/30',
    buttonHover: 'hover:bg-[#2979ff] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#2979ff]/10',
  },
  Legal: {
    iconBg: 'bg-[#a200f2]',
    cardBorder: 'border-[#a200f2]/30',
    tagBg: 'bg-[#a200f2]/10',
    tagText: 'text-[#a200f2]',
    iconColor: 'text-[#a200f2]',
    buttonBg: 'bg-[#a200f2]/10',
    buttonText: 'text-[#a200f2]',
    buttonBorder: 'border-[#a200f2]/30',
    buttonHover: 'hover:bg-[#a200f2] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#a200f2]/10',
  },
  DP: {
    iconBg: 'bg-[#672c71]',
    cardBorder: 'border-[#672c71]/30',
    tagBg: 'bg-[#672c71]/10',
    tagText: 'text-[#672c71]',
    iconColor: 'text-[#672c71]',
    buttonBg: 'bg-[#672c71]/10',
    buttonText: 'text-[#672c71]',
    buttonBorder: 'border-[#672c71]/30',
    buttonHover: 'hover:bg-[#672c71] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#672c71]/10',
  },
  Sucesso: {
    iconBg: 'bg-[#64dd17]',
    cardBorder: 'border-[#64dd17]/30',
    tagBg: 'bg-[#64dd17]/10',
    tagText: 'text-[#64dd17]',
    iconColor: 'text-[#64dd17]',
    buttonBg: 'bg-[#64dd17]/10',
    buttonText: 'text-[#64dd17]',
    buttonBorder: 'border-[#64dd17]/30',
    buttonHover: 'hover:bg-[#64dd17] hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-[#64dd17]/10',
  },
};

const TemplateCard = ({
  title,
  department,
  id,
  amount,
  isCreateTemplate = false,
  onClick = () => { }
}) => {
  function hexToRgba(hex, alpha = 1) {
    const rawHex = hex.replace('#', '');
    const bigint = parseInt(rawHex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  const [isHovered, setIsHovered] = useState(false);
  const [style, setStyle] = useState(departmentStyles.default);
  const [cardCount, setCardCount] = useState(0);

  useEffect(() => {
    const storedDepartments = JSON.parse(localStorage.getItem('departments')) || [];
    const normalize = (str) =>
      str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const found = storedDepartments.find(dep =>
      normalize(dep.nome) === normalize(department)
    );

    if (found?.corSequencia) {
      const hex = found.corSequencia;
      setStyle({
        iconBg: hexToRgba(hex, 1),
        cardBorder: hexToRgba(hex, 0.3),
        tagBg: hexToRgba(hex, 0.1),
        tagText: hex,
        buttonBg: hexToRgba(hex, 0.1),
        buttonText: hex,
        buttonBorder: hexToRgba(hex, 0.3),
        buttonHoverBg: hexToRgba(hex, 1),
      });
    }

    const allSequences = JSON.parse(localStorage.getItem("sequences")) || [];
    const matchedSequence = allSequences.find(seq =>
      normalize(seq.title) === normalize(title)
    );

    if (matchedSequence?.id) {
      const kanban = JSON.parse(localStorage.getItem(`kanban-${matchedSequence.id}`));
      if (kanban) {
        const total = Object.values(kanban).reduce((sum, col) =>
          sum + (col.items?.length || 0), 0
        );
        setCardCount(total);
      }
    }

  }, [department, title]);

  useEffect(() => {
    if (id) {
      const kanban = JSON.parse(localStorage.getItem(`kanban-${id}`));
      if (kanban) {
        const total = Object.values(kanban).reduce(
          (sum, col) => sum + (col.items?.length || 0), 0
        );
        setCardCount(total);
      }
    }
  }, [id]);

  const createCardStyle = {
    iconBg: 'bg-blue-700',
    cardBorder: 'border border-blue-700',
    tagBg: 'bg-blue-50',
    tagText: 'text-blue-700',
    buttonBg: 'bg-blue-100',
    buttonText: 'text-blue-700',
    buttonBorder: 'border-blue-300',
    buttonHover: 'hover:bg-blue-700 hover:text-white hover:bg-opacity-70',
    cardHover: 'hover:bg-blue-100',
  };

  const currentStyle = isCreateTemplate ? createCardStyle : style;

  return (
    <div 
      className="bg-white rounded-lg border p-5"
      style={{ borderColor: style.cardBorder }}
    >
      <div className="flex items-center gap-3 mb-4">
        <div 
          className="w-8 h-8 rounded-full flex items-center justify-center"
          style={{ backgroundColor: style.iconBg }}
        >
          <FiCommand className='text-white' size={20}/>
        </div>
        <span className="text-base font-semibold text-gray-800">{title}</span>
      </div>

      <div 
        className="rounded-full py-1 px-3 inline-block mb-3"
        style={{ backgroundColor: style.tagBg }}
      >
        <span className="text-xs font-medium" style={{ color: style.tagText }}>
          {isCreateTemplate ? "Nova sequência" : department}
        </span>
      </div>

      <p className="text-sm text-gray-700 mb-4">
        {isCreateTemplate ? "0 Cards" : `${cardCount} Cards`}
      </p>

      
      <button
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? style.buttonHoverBg : style.buttonBg,
          color: isHovered ? '#ffffff' : style.buttonText,
          borderColor: style.buttonBorder,
          transition: 'all 0.2s ease'
        }}
        className="w-full text-sm py-[0.45rem] px-2 rounded-2xl font-semibold border"
      >
        Ver sequência
      </button>
    </div>

  );
};

export default TemplateCard;